import { render, staticRenderFns } from "./BtnView.vue?vue&type=template&id=fb459880&scoped=true&"
import script from "./BtnView.vue?vue&type=script&lang=js&"
export * from "./BtnView.vue?vue&type=script&lang=js&"
import style0 from "./BtnView.vue?vue&type=style&index=0&id=fb459880&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb459880",
  null
  
)

export default component.exports